export const bobLineAt = 'https://line.me/R/ti/p/@047srgha'
